import swal from "sweetalert";
import Swal from "sweetalert2";

export function insereQuebraLinha(text) {
    return replaceAll(text, "\\n", "\n");
};

export function replaceAll(string, search, replace) {
    return string.split(search).join(replace);
}

export function dateNowBR() {
    let dia = new Date().toLocaleString("pr-BR", {day: "2-digit"});
    let mes = new Date().toLocaleString("pr-BR", {month: "2-digit"});
    let ano = new Date().toLocaleString("pr-BR", {year: "numeric"});
    return dia + "/" + mes + "/" + ano; //DD/MM/YYYY
}

export function timeNow(segundos = true) {
    let hora = new Date().getHours();
    if (hora < 10)
        hora = "0" + hora;

    let minuto = new Date().getMinutes();
    if (minuto < 10)
        minuto = "0" + minuto

    let segundo = new Date().getSeconds();
    if (segundo < 10)
        segundo = "0" + segundo;

    if (segundos) 
        return hora + ":" + minuto + ":" + segundo;
    else
        return hora + ":" + minuto;
}

export function dateTimeNowBR(segundos = true) {
    return `${dateNowBR()} ${timeNow(segundos)}`;
};

export function mensagemErro(title, text, html, funcaoOK) {
    Swal.fire({
        title: title,
        text: ! html ? text : undefined,
        icon: "error",
        html: html ? insereQuebraLinha(text): undefined,
        heightAuto: false,
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: funcaoOK,
        confirmButtonColor: "dodgerblue",
        backdrop: false,
        allowOutsideClick: false,
        allowEscapeKey: false
    }).then((result) => {
        if (funcaoOK)
            funcaoOK();
    });  
}

export function mensagemSucesso(title, text, html, funcaoOK) {
    Swal.fire({
        title: title,
        text: ! html ? text : undefined,
        icon: "success",
        html: html ? insereQuebraLinha(text): undefined,
        heightAuto: false,
        showCloseButton: false,
        showCancelButton: false,
        showConfirmButton: funcaoOK,
        confirmButtonColor: "dodgerblue",
        backdrop: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
    }).then((result) => {
        if (funcaoOK)
            funcaoOK();
    }); 
}

export function confirmacao(text, funcao_yes, funcao_no) {
    swal({
        title: insereQuebraLinha(text),
        text: "",
        icon: require("./assets/img/icon_question.png"),
        dangerMode: true,
        buttons: {
            cancel: "NÃO",
            yes: {
                "text": "SIM",
                "alue": "SIM"    
            }
        }
    }).then((value) => {
        if (value === "yes" && funcao_yes) 
            funcao_yes();
        else if (funcao_no) 
            funcao_no();       
    });    
}

export function validaCPF(cpf) {
    let soma = 0;
    let resto;
    let i;
  
    let strCPF = String(cpf).replace(/[^\d]/g, "");
    
    if (strCPF.length !== 11)
        return false;
    
    if (["00000000000", "11111111111", "22222222222", "33333333333", "44444444444", "55555555555", "66666666666", "77777777777", "88888888888", "99999999999"].indexOf(strCPF) !== -1)
        return false;
  
    for (i = 1; i <= 9; i++)
        soma = soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
  
    resto = (soma * 10) % 11;
  
    if ((resto === 10) || (resto === 11)) 
        resto = 0;
  
    if (resto !== parseInt(strCPF.substring(9, 10)) )
        return false;
  
    soma = 0;
  
    for (i = 1; i <= 10; i++)
        soma = soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
  
    resto = (soma * 10) % 11;
  
    if ((resto === 10) || (resto === 11)) 
        resto = 0;
  
    if (resto !== parseInt(strCPF.substring(10, 11)))
        return false;
  
    return true;
}

export function getParam(param) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get(param))
        return urlParams.get(param);
    else
        return "";
}

export function getPathName() {
    let urlParsed = '';

    if (window?.location?.pathname) {
        urlParsed = window.location.pathname;
    }
   
    return urlParsed;
}